import React from 'react';
import { FormInstance } from 'antd/es/form/Form';
import { useTranslation } from 'react-i18next';

import { FormOnSubmitType, OpForm } from 'new-components/DLS/OpForm/OpForm';

import './EmailForm.scss';

export interface EmailFormInstance {
  email: string;
}

interface EmailForm {
  form: FormInstance<EmailFormInstance>;
  isSubmitting: boolean;
  initialValues?: { email: string | null };
  onSubmit: FormOnSubmitType;
}

/**
 * @component
 * @description Component that asks for the users email. Will show error if no allowed namespaces are found for the email.
 */
export const EmailForm = ({
  form,
  onSubmit,
  initialValues,
  isSubmitting,
}: EmailForm) => {
  const { t } = useTranslation();

  return (
    <OpForm
      className="email-form"
      hasError={false}
      form={form}
      initialValues={initialValues}
      onSubmit={onSubmit}
      defaultButtons={false}
      shouldWarnChangesBeforeUnload={false}
    >
      <OpForm.Input
        validateTrigger="onSubmit"
        rules={[
          { required: true, message: t('Email is required') },
          { type: 'email', message: t('Email is not valid') },
        ]}
        label={t('Email')}
        name="email"
        onChange={(e) => {
          // remove white spaces
          form.setFieldValue('email', e.target.value.trim());
        }}
      />
      <OpForm.Button
        className="email-form__submit"
        type="primary"
        loading={isSubmitting}
        onClick={() => {
          form.submit();
        }}
      >
        {t('Continue')}
      </OpForm.Button>
    </OpForm>
  );
};
